import React from 'react';
import Spline from '@splinetool/react-spline';

function SplineScene() {
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <Spline scene="https://prod.spline.design/bBg1jE270-BD7GXI/scene.splinecode" />
    </div>
  );
}

export default SplineScene;
